import Phaser from 'phaser';
import { LOGICAL_WIDTH, WORLD_HEIGHT } from '../dimensions';
import { PLAY_MARGIN_X } from './Playfield';

export function createWalls(scene: Phaser.Scene): void {
  const M = scene.matter;
  const T = 20;
  const half = T / 2;
  // Left wall — spans the world height
  M.add.rectangle(PLAY_MARGIN_X - half, WORLD_HEIGHT / 2, T, WORLD_HEIGHT, { isStatic: true, label: 'wall' });
  // Right wall
  M.add.rectangle(LOGICAL_WIDTH - PLAY_MARGIN_X + half, WORLD_HEIGHT / 2, T, WORLD_HEIGHT, { isStatic: true, label: 'wall' });
  // Top wall (at y = 0)
  M.add.rectangle(LOGICAL_WIDTH / 2, -half, LOGICAL_WIDTH, T, { isStatic: true, label: 'wall' });
  // Bottom catch tray (defensive — sits below the world)
  M.add.rectangle(LOGICAL_WIDTH / 2, WORLD_HEIGHT + half, LOGICAL_WIDTH, T, { isStatic: true, label: 'catch' });
}
